export function getInitials(user: Record<string, any>): string {
  const firstName = user.firstName;
  const lastName = user.lastName;
  return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
}

export function generateRandomId(): string {
  // Use crypto.getRandomValues for cryptographically secure random values
  const array = new Uint8Array(8);
  crypto.getRandomValues(array);
  const randomPart = Array.from(array, byte => byte.toString(36))
    .join('')
    .substring(0, 8);
  return randomPart + Date.now().toString(36);
}

export function getAllDefaultPrompts(): string[] {
  return Object.values(DEFAULT_PROMPTS_BY_ENTITY.lease).flat();
}

export function getDefaultPromptsByEntity(entity: string): string[] {
  return DEFAULT_PROMPTS_BY_ENTITY[entity] || [];
}

// Map of default prompts by entity
export const DEFAULT_PROMPTS_BY_ENTITY: Record<string, string[]> = {
  space: [
    'Find available Space in [District] between [Min SF] and [Max SF]',
    'Give me a list of all Spaces in [District] expiring after [Date] or between [Date 1] and [Date 2]',
    'Give me a list of all Spaces where [Company Name] was the Tenant',
    'Give me a list of Space with [Total Monthly Outgoing] from $xxxK to $xxxK',
    'Give me a list of Space with [Achievable Rent ($per sf) ]between $xxxK to $xxxK',
    'Give me a list of Space with [Effective Rent] between $xxxK to $xxxK',
    'Show me spaces in [District] with lease expiry after [Date] and effective rent below [Value]',
    'Give me a list of tenant in [District] which is over [XXX sf G]',
  ],
  lease: [
    'Give me a list of all current <Office/Retail/Industrial> leases in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF>',
    'Give me a list of all  <Office/Retail/Industrial> leases in the <Market/Submarket/District/Neighborhood> expiring after <Date> or between <Date 1> and <Date 2>',
    'Give me a list of all leases in the <Market/Submarket/District/Neighborhood> where <Company Name> was the Tenant ',
    'Give me a list of all leases in the <Market/Submarket/District/Neighborhood> where <Company Name> was the <Listing Rep/Tenant Rep>',
    'Give me the footprint of <Parent Company> in the <Market/Submarket/District/Neighborhood>',
  ],
  availability: [
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF> considering the Maximum contiguous space',
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> where the Listing Rep is <Company Name>',
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF> considering the Maximum contiguous space with the Asking Rate between <Min> and <Max>',
  ],
  property: [
    'Give me a summary of <Property Name /Address> including details of the Availabilities and Leases ',
    'Give me a list of <Office/Retail/Industrial> Properties with contiguous Availability over <X SF> in the <Market/Submarket/District/Neighborhood> ',
    'Give me a list of <Office/Retail/Industrial> Properties with contiguous Availability over <X SF> in the <Market/Submarket/District/Neighborhood> where the Asking Rate is between <$x> and <$y> ',
  ],
  company: [
    "Of the Companies with the name <Company Name> as a Tenant on Leasesin <Market/Submarket>, which one has the most deals associated with it? Please provide the Company ID and how many deals it's associated with",
  ],
};

export const ENTITY_BY_PROMPT_MAP: Record<string, Record<string, string[]>> = {
  space: { space: DEFAULT_PROMPTS_BY_ENTITY.space },
  lease: { leases: DEFAULT_PROMPTS_BY_ENTITY.lease },
  availability: { availabilities: DEFAULT_PROMPTS_BY_ENTITY.availability },
  property: { property: DEFAULT_PROMPTS_BY_ENTITY.property },
  company: { company: DEFAULT_PROMPTS_BY_ENTITY.company },
};
